import Head from 'expo-router/head';

import { CartScreen } from '@fhs/cart';
import { Cart as LegacyCart } from '@fhs-legacy/frontend/src/pages/cart/cart';
import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function CartPageWithFlag() {
  const enableCartService = useFlag('enable-simply-better-cart-service');

  return (
    <>
      <Head>
        <title>Cart - Firehouse Subs</title>
      </Head>
      {enableCartService ? <CartScreen /> : <LegacyCart />}
    </>
  );
}
